// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"CustomerWiseAPISalesPendingPage_headerActions__1Q2zF"};